import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3325677575/src/website/app/[locale]/(search)/coworking/_components/DayPassesSearch.tsx");
